import { Global, css } from '@emotion/react'
import 'normalize.css'
import pattern from '../assets/img/pattern.png'
import { mediaQueries, theme } from './theme'

export const GlobalStyles = (): JSX.Element => {
  return (
    <Global
      styles={css`
        :root {
          --toastify-toast-min-height: 44px;

          --safe-top: env(safe-area-inset-top);
          --safe-bottom: env(safe-area-inset-bottom);
          --safe-left: env(safe-area-inset-left);
          --safe-right: env(safe-area-inset-right);
        }

        html,
        body,
        #root {
          width: 100%;
          height: 100%;
          min-height: 100%;
          padding: 0;
          margin: 0;
        }

        body {
          font-family: 'Roboto', sans-serif;
          color: ${theme.colors.var1};
          //background-color: #000;
          background-repeat: repeat;
          background-image: url(${pattern});
        }

        input {
          touch-action: none;
        }

        *,
        *:after,
        *:before {
          box-sizing: border-box;
        }

        .Toastify__toast-container--top-right {
          top: 1.5em;
          right: 1.5em;
        }

        .Toastify__toast-body {
          font-size: 12px;

          ${mediaQueries.medium} {
            font-size: 14px;
          }
        }
      `}
    />
  )
}
